import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class PasswordResetService {
	private submitNewPassworldUrl = environment.baseApiUrl + 'tool/password/{TokenReset}';
	private recoverPassworldUrl = environment.baseApiUrl + 'tool/recoverPassword';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	submitNewPassword(tokenReset: string, email: string, newPassword: string): Observable<JSON[]> {
		const headers = tokenReset ? new HttpHeaders({ Authorization: 'Bearer ' + tokenReset }) : null;
		const submitNewPassworldUrl = this.submitNewPassworldUrl.replace('{TokenReset}', tokenReset);
		const body = { email: email, password: newPassword };
		return this.http.post<JSON[]>(submitNewPassworldUrl, body, headers ? { headers: headers } : null);
	}

	recoverPassword(email: string, newPassword: string): Observable<JSON[]> {
		const body = { email: email, password: newPassword };
		return this.http.post<JSON[]>(this.recoverPassworldUrl, body);
	}
}
